import { useEffect, useState } from 'react';

export const useIsIOS = () => {
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    const checkIOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || '';
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 1;
      const isIOS = /iPhone|iPod|iPad/.test(userAgent) || (/Macintosh/.test(userAgent) && isTouchDevice);
      return isIOS;
    };

    setIsIOSDevice(checkIOS());
  }, []);

  return isIOSDevice;
};
